import React, { useEffect, useMemo } from 'react';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { getFilters } from '../../Components/Common/Filter';

import { createSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { getAudits } from '../../slices/audits/thunk';
import { formatUtcDate } from '../../helpers/format';
import { isEmpty } from 'lodash';
import TableAuditManagement from './components/TableAuditManagement';
import useQsParams from '../../Components/Hooks/QueryString';
import { translations } from './action';
import { Can } from '../../helpers/casl';
import { Link } from 'react-router-dom';

const AuditManagement = (props) => {
  const dispatch = useDispatch();
  const { searchParams, setSearchParams } = useQsParams();

  const AuditState = createSelector(
    (state) => state.Audit.audits,
    (audits) => audits,
  );

  const loadingState = createSelector(
    (state) => state.Audit.isLoading,
    (isLoading) => isLoading,
  );

  const metaState = createSelector(
    (state) => state.Audit.meta,
    (meta) => meta,
  );

  const audits = useSelector(AuditState);
  const isLoading = useSelector(loadingState);
  const meta = useSelector(metaState);

  useEffect(() => {
    getData();
  }, [dispatch, searchParams.toString()]);

  const auditAction = [
    {
      label: props.t(`audit-management.action.table.create`),
      value: 'create',
    },
    {
      label: props.t(`audit-management.action.table.delete`),
      value: 'delete',
    },
    {
      label: props.t(`audit-management.action.table.update`),
      value: 'update',
    },
  ];

  const getTranslationAuditAction = (action) => {
    return (
      translations[action] ?? {
        label: 'Não mapeado',
        color: 'esquecémo-dinuevo',
      }
    );
  };

  const getData = () => {
    const params = { page: searchParams.get('page') ?? 1 };
    const appliedFilters = getFilters([], [
      { field: 'action', type: 'in' },
      { field: 'createdAt', type: 'date' },
      { field: 'email', type: 'like' },
    ]);

    if (!isEmpty(appliedFilters)) {
      params.filters = appliedFilters;
    }

    dispatch(getAudits(params));
  };

  const columns = useMemo(
    () => [
      {
        Header: props.t('audit-management.table.email'),
        Cell: (props) => props.row.original.email || '-',
        reportProps: {
          accessor: 'email',
        },
      },
      {
        Header: props.t('audit-management.table.action'),
        accessor: 'action',
        filterable: false,
        Cell: (props) => {
          const translation = getTranslationAuditAction(props.row.original.action);

          return (
            <React.Fragment>
              <span className={`badge rounded-pill ${translation.color}`}>{translation.label}</span>
            </React.Fragment>
          );
        },
      },
      {
        Header: props.t('audit-management.table.event'),
        accessor: 'event',
        filterable: false,
        Cell: (props) => (
          <div style={{ maxWidth: 180 }}>
            <label title={props.row.original.event || '-'} className="text-truncate m-0 w-100">
              {props.row.original.event || '-'}
            </label>
          </div>
        ),
      },
      {
        Header: props.t('audit-management.table.origin'),
        accessor: 'origin',
        filterable: false,
        Cell: (props) => props.row.original.origin || '-',
      },
      {
        Header: props.t('audit-management.table.microservice'),
        accessor: 'microservice',
        filterable: false,
        Cell: (props) => props.row.original.microservice || '-',
      },
      {
        Header: props.t('audit-management.table.module'),
        accessor: 'module',
        filterable: false,
        Cell: (props) => props.row.original.module || '-',
      },
      {
        Header: props.t('audit-management.table.ip'),
        accessor: 'ip',
        filterable: false,
        Cell: (props) => props.row.original.ip || '-',
      },
      {
        Header: props.t('audit-management.table.path'),
        accessor: 'path',
        filterable: false,
        Cell: (props) => props.row.original.path || '-',
      },
      {
        Header: props.t('audit-management.table.created_at'),
        accessor: 'date',
        filterable: false,
        Cell: (props) => formatUtcDate(props.row.original.createdAt),
        reportProps: {
          formatter: {
            type: 'date',
            properties: { tz: 'America/Sao_Paulo', format: 'DD/MM/YYYY' },
          },
        },
      },
      {
        Header: props.t('actions'),
        Cell: (props) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <Can I="read" a="general_settings">
                <li className="list-inline-item">
                  <Link to={`${props?.row?.original?.id}`}>
                    <i className="ri-eye-fill align-bottom text-muted" />
                  </Link>
                </li>
              </Can>
            </ul>
          );
        },
      },
    ],
    [],
  );

  document.title = 'Gestão de auditoria | Opencashback';

  return (
    <React.Fragment>
      <TableAuditManagement
        props={props}
        columns={columns}
        searchParams={searchParams}
        isLoading={isLoading}
        audits={audits}
        auditAction={auditAction}
        meta={meta}
        page={searchParams.get('page')}
        setPage={(p) => setSearchParams('page', p)}
      />
    </React.Fragment>
  );
};

export default withTranslation()(AuditManagement);
